var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Col, Row } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
var SubLeadDetails = function (props) {
    var _a;
    var _b = __read(React.useState(props.subLeadData), 2), childLeadData = _b[0], setChildLeadData = _b[1];
    React.useEffect(function () {
        setChildLeadData(props.subLeadData);
    }, [props.subLeadData]);
    return (React.createElement(GridContainer, { parentClass: "d-flex flex-column gap-4 sub-details-container" }, (props === null || props === void 0 ? void 0 : props.isChild) ? (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "pdb-40 comments-row input-error" }, ((_a = props === null || props === void 0 ? void 0 : props.parentLeadId) === null || _a === void 0 ? void 0 : _a.length) > 0 && (React.createElement(Col, { className: "d-flex flex-column gap-2" },
            React.createElement("div", { className: "px-0 flexJustifySpaceBetween mbt-5" },
                React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Partner Lead Id")),
            React.createElement("div", { className: "DMSanN_16_400 child-lead-id-wrapper" }, props === null || props === void 0 ? void 0 : props.parentLeadId)))))) : (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { className: "d-flex align-items-center justify-content-end gap-2" },
                React.createElement("i", { className: "edel-icon-Add" }),
                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", type: "button", value: "Create New Child Lead", onClick: function () {
                        props.createNewChildLeadURL();
                    } }))),
        React.createElement(Row, { className: "pdb-40 comments-row input-error" }, childLeadData.length > 0 &&
            childLeadData.map(function (child, index) {
                return (React.createElement(Col, { className: "d-flex flex-column gap-2" },
                    React.createElement("div", { className: "px-0 flexJustifySpaceBetween mbt-5" },
                        React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" },
                            "Client Lead Id ",
                            index + 1)),
                    React.createElement("div", { className: "DMSanN_16_400 child-lead-id-wrapper" }, child.leadId)));
            }))))));
};
export default SubLeadDetails;
